import { Entity } from '@backstage/catalog-model';
import { InfoCard } from '@backstage/core-components';
import { AboutField } from '@backstage/plugin-catalog';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Grid } from '@backstage/ui';

type Criticality = {
  tier: string;
  importance?: string;
  urgency?: string;
  journey?: string;
};

export function hasCriticality(entity: Entity): boolean {
  return entity?.spec?.criticality !== undefined;
}

export function CriticalityCard() {
  const { entity } = useEntity();
  const criticality = entity?.spec?.criticality as Criticality | undefined;

  if (!criticality) {
    return null;
  }

  const columns = { initial: '1', sm: '2', lg: '3' } as const;

  return (
    <InfoCard title="Criticality">
      <Grid.Root columns={columns} gap="3">
        <Grid.Item>
          <AboutField label="Tier" value={criticality?.tier} />
        </Grid.Item>
        <Grid.Item>
          <AboutField label="Importance" value={criticality?.importance} />
        </Grid.Item>
        <Grid.Item>
          <AboutField label="Urgency" value={criticality?.urgency} />
        </Grid.Item>
        {criticality?.journey && (
          <Grid.Item>
            <AboutField label="Journey" value={criticality.journey} />
          </Grid.Item>
        )}
      </Grid.Root>
    </InfoCard>
  );
}
